import React, {Component} from 'react';

export default class ButtonGroupContent extends Component {
  /** @function
   * Renders the Title Content component.
   */
  render() {
    const buttons = this.props.buttons.map((btn, index)=>(
      <a className="button" href={btn.url} key={index} target="_blank">
        {btn.text}
      </a>
    ));
    return (
      <div className="button-group">
        {buttons}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/button-group-content.js